import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { APP_CONFIG } from './app/configs/app-configuration';
import { AppModule } from './app/app.module';
import {
  APP_SETTINGS,
  ERROR_MESSAGES,
  SPACE_FEATURES_ICON,
  SPACE_TYPE_ICON
} from './app/services/user-settings.service';
import { environment } from './environments/environment';


const configLoadedEventName = 'm4m-config-loaded'; // event to describe when app config retched & ready to use
const mainTsLoadedEventName = 'm4m-mainTs-loaded'; // event to describe when main.ts file is loaded & ready to use
const angularLoadedEventName = 'm4m-angular-loaded'; // event to describe when angular is loaded & ready to use
const mainTsLoadedEvent = new Event(mainTsLoadedEventName);
const angularLoadedEvent = new Event(angularLoadedEventName);


if (environment.production) {
  enableProdMode();
  window.console.log = function () { };
}

// 1. Dispatch event that file is ready
window.document.dispatchEvent(mainTsLoadedEvent);


// 2. Listen config event & run angular
Promise.all([getLocalAppConfig(),  getAuthConfig()]).then(([appConfig, authResponseConfig]) => {
  const {appSettings, errorMessages,  spaceFeaturesIcons, setupTypeIcon} = appConfig;
  console.log({appConfig, authResponseConfig})

  const authConfig = {
    ...authResponseConfig,
    redirectUri: window.location.origin,
    showDebugInformation: true,
    strictDiscoveryDocumentValidation: false,
  }
  const appSettings2 ={
    ...appSettings,
    HotelingCloudApiUrl: 'https://dmgtxproxy.deloitte.com' + '/concierge/api/'
  }

  console.log('!!!!!!!!!! APP Was Running !!!!!!!!')

  return platformBrowserDynamic([
    { provide: APP_CONFIG, useValue: authConfig },
    { provide: APP_SETTINGS, useValue: appSettings2 },
    { provide: ERROR_MESSAGES, useValue: errorMessages },
    { provide: SPACE_FEATURES_ICON, useValue: spaceFeaturesIcons },
    { provide: SPACE_TYPE_ICON, useValue: setupTypeIcon },
  ])
    .bootstrapModule(AppModule)

})
  // 3. Dispatch event that angular is ready
  .then(()=>window.document.dispatchEvent(angularLoadedEvent))
  .catch((err) => console.error(err));

function getLocalAppConfig():Promise<any>{
  return fetchByUrl('/assets/config.json')
}

function getAuthConfig():Promise<any>{
  return new Promise<any>((resolve) => {
    window.document.addEventListener(configLoadedEventName, (event) => {
      console.log(configLoadedEventName, ' !!!! ', event)

      // @ts-ignore
      const config = event?.detail ?? {};
      resolve(Object.keys(config).length ? config : { });

    });
  });
}

function fetchByUrl(url, options = undefined) {
  return fetch(url, options)
    .then((response) => response.json())
    .catch(() => null);
}
